import { jsx, jsxs } from 'react/jsx-runtime';
import { Chip, Text } from '@flex-design-system/fx';
import { NumberIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';

function HashPlaceholderComponent({ displayText }) {
  return (
    // minHeight은 stitches로 적용 시 linear에서 넣어주는 값에 가려져서 style prop으로 넣습니다.
    /* @__PURE__ */ jsx(HashPlaceholder, { style: { minHeight: "22px" }, children: /* @__PURE__ */ jsxs(Chip.Content, { clickableStyle: "none", css: { padding: "0 4px" }, children: [
      /* @__PURE__ */ jsx(Label, { children: /* @__PURE__ */ jsx(NumberIcon, { size: 14, color: "cosmicBlueDark" }) }),
      /* @__PURE__ */ jsx(Chip.Value, { children: /* @__PURE__ */ jsx(Text, { weight: 600, children: displayText }) })
    ] }) })
  );
}
const HashPlaceholder = styled(Chip, {
  margin: "0 3px",
  lineHeight: "22px"
});
const Label = styled(Chip.Label, {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 14,
  height: 14,
  fontSize: 14,
  marginRight: 2
});

export { HashPlaceholderComponent };
//# sourceMappingURL=HashPlaceholderComponent.mjs.map
